import operationTypes from 'constants/operationTypes';
import { getOperationsByPartner } from 'modules/transactions/api/getOperationsByPartner';
import { Operation, Partner, Society } from 'types';

export type OperationType =
  (typeof operationTypes)[keyof typeof operationTypes];

type Props = {
  partner: Partner;
  society: Society;
  operationType: OperationType | OperationType[];
};

export const getPartnerOperationsFromType = async ({
  partner,
  society,
  operationType,
}: Props) => {
  try {
    const partnerOperations = (await getOperationsByPartner({
      societyId: society._id,
      partnerId: partner._id,
      filterBy: operationType,
    })) as { data: Operation[] };

    return partnerOperations?.data || [];
  } catch {
    return [];
  }
};
